import React, { useState, useEffect, useContext } from "react";
import { FaUserPlus } from "react-icons/fa";
import { AuthContext } from "../../context/AuthContext";

export default function ProspectoForm({ cargarProspectos, onGuardado }) {
  const { token } = useContext(AuthContext);

  const [miembros, setMiembros] = useState([]);
  const [clubs, setClubs] = useState([]);
  const [toast, setToast] = useState({ mostrar: false, mensaje: "", tipo: "success" });

  const [form, setForm] = useState({
    nombre: "",
    direccion: "",
    colonia: "",
    ciudad: "",
    telefono: "",
    etapa: "",
    id_miembro: "",
    id_club: "",
    tiempo: "",
    acepto: 0,
    visitar: 0,
    ruta: 0,
    observaciones: "",
  });

  const mostrarToast = (mensaje, tipo = "success") => {
    setToast({ mostrar: true, mensaje, tipo });
    setTimeout(() => setToast({ mostrar: false, mensaje: "", tipo: "success" }), 3000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // ========================
  // CARGAR MIEMBROS
  // ========================
  const cargarMiembros = async () => {
    try {
      const res = await fetch("/api/miembros", {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setMiembros(data);
    } catch (error) {
      console.error("Error cargando miembros:", error);
    }
  };

  // ========================
  // CARGAR CLUBS
  // ========================
  const cargarClubs = async () => {
    try {
      const res = await fetch("/api/clubs", {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setClubs(data);
    } catch (error) {
      console.error("Error cargando clubs:", error);
    }
  };

  useEffect(() => {
    cargarMiembros();
    cargarClubs();
  }, []);

  // ========================
  // GUARDAR PROSPECTO
  // ========================
  const guardar = async () => {
    try {
      // Los selects opcionales (etapa, miembro, club) quedan en "" si no se
      // eligen; hay que mandarlos como null porque las columnas son enteras.
      const payload = {
        ...form,
        etapa: form.etapa || null,
        id_miembro: form.id_miembro || null,
        id_club: form.id_club || null,
      };

      const res = await fetch("/api/prospectos", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        mostrarToast("Prospecto registrado correctamente.");

        // Refrescar tabla
        cargarProspectos();

        // Limpiar formulario
        setForm({
          nombre: "",
          direccion: "",
          colonia: "",
          ciudad: "",
          telefono: "",
          etapa: "",
          id_miembro: "",
          id_club: "",
          tiempo: "",
          acepto: 0,
          visitar: 0,
          ruta: 0,
          observaciones: "",
        });

        onGuardado?.();
      } else {
        mostrarToast(data.message || "Error al guardar prospecto.", "error");
      }
    } catch (error) {
      console.error("Error guardando prospecto:", error);
      mostrarToast("Error de conexión con el servidor.", "error");
    }
  };

  const inputClass =
    "w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400";

  return (
    <div>
      {toast.mostrar && (
        <div className={`fixed top-5 right-5 z-[70] px-4 py-3 rounded-lg shadow-lg text-sm text-white ${toast.tipo === "success" ? "bg-emerald-600" : "bg-rose-600"}`}>
          {toast.mensaje}
        </div>
      )}

      <div className="grid grid-cols-2 gap-x-4 gap-y-2.5">

        {/* Nombre */}
        <div className="col-span-2">
          <label className="block text-xs font-medium text-slate-700 mb-1">Nombre</label>
          <input className={inputClass} name="nombre" placeholder="Nombre completo" value={form.nombre} onChange={handleChange} />
        </div>

        {/* ETAPA */}
        <div className="flex items-center gap-2">
          <label className="text-xs font-medium text-slate-700 shrink-0">Etapa</label>
          <div className="flex flex-wrap gap-x-2 gap-y-1 text-sm text-slate-600">
            <label className="flex items-center gap-1">
              <input type="radio" name="etapa" value="1" checked={form.etapa === "1"} onChange={handleChange} className="accent-indigo-600" /> Adulto
            </label>
            <label className="flex items-center gap-1">
              <input type="radio" name="etapa" value="2" checked={form.etapa === "2"} onChange={handleChange} className="accent-indigo-600" /> Joven
            </label>
            <label className="flex items-center gap-1">
              <input type="radio" name="etapa" value="3" checked={form.etapa === "3"} onChange={handleChange} className="accent-indigo-600" /> Niño
            </label>
          </div>
        </div>

        {/* RUTA */}
        <div className="flex items-center gap-2">
          <label className="text-xs font-medium text-slate-700 shrink-0">¿Por la ruta?</label>
          <div className="flex flex-wrap gap-x-2 gap-y-1 text-sm text-slate-600">
            <label className="flex items-center gap-1">
              <input type="radio" name="ruta" value="0" checked={form.ruta === "0"} onChange={handleChange} className="accent-indigo-600" /> No
            </label>
            <label className="flex items-center gap-1">
              <input type="radio" name="ruta" value="1" checked={form.ruta === "1"} onChange={handleChange} className="accent-indigo-600" /> Sí
            </label>
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Dirección</label>
          <input className={inputClass} name="direccion" placeholder="Dirección" value={form.direccion} onChange={handleChange} />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Colonia</label>
          <input className={inputClass} name="colonia" placeholder="Colonia" value={form.colonia} onChange={handleChange} />
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Ciudad</label>
          <input className={inputClass} name="ciudad" placeholder="Ciudad" value={form.ciudad} onChange={handleChange} />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Teléfono</label>
          <input className={inputClass} name="telefono" placeholder="Teléfono" value={form.telefono} onChange={handleChange} />
        </div>

        {/* MIEMBRO */}
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Visita hecha por</label>
          <select name="id_miembro" className={inputClass} value={form.id_miembro} onChange={handleChange}>
            <option value="">-- Selecciona --</option>
            {miembros.map((m) => (
              <option key={m.id_miembro} value={m.id_miembro}>
                {m.nombre} {m.paterno || ""}
              </option>
            ))}
          </select>
        </div>

        {/* CLUB */}
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Club bíblico (opcional)</label>
          <select name="id_club" className={inputClass} value={form.id_club} onChange={handleChange}>
            <option value="">-- Selecciona --</option>
            {clubs.map((c) => (
              <option key={c.id_club} value={c.id_club}>
                {c.nombre_club}
              </option>
            ))}
          </select>
        </div>

        {/* TIEMPO */}
        <div className="col-span-2">
          <label className="block text-xs font-medium text-slate-700 mb-1">Mejor tiempo para visitar</label>
          <input className={inputClass} name="tiempo" placeholder="Ej. Sábados por la tarde" value={form.tiempo} onChange={handleChange} />
        </div>

        {/* ACEPTO + VISITAR */}
        <div className="flex items-center gap-2">
          <label className="text-xs font-medium text-slate-700 shrink-0">Aceptó a Cristo</label>
          <div className="flex gap-2 text-sm text-slate-600">
            <label className="flex items-center gap-1">
              <input type="radio" name="acepto" value="1" checked={form.acepto === "1"} onChange={handleChange} className="accent-indigo-600" /> Sí
            </label>
            <label className="flex items-center gap-1">
              <input type="radio" name="acepto" value="0" checked={form.acepto === "0"} onChange={handleChange} className="accent-indigo-600" /> No
            </label>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <label className="text-xs font-medium text-slate-700 shrink-0">Visitar después</label>
          <div className="flex gap-2 text-sm text-slate-600">
            <label className="flex items-center gap-1">
              <input type="radio" name="visitar" value="1" checked={form.visitar === "1"} onChange={handleChange} className="accent-indigo-600" /> Sí
            </label>
            <label className="flex items-center gap-1">
              <input type="radio" name="visitar" value="0" checked={form.visitar === "0"} onChange={handleChange} className="accent-indigo-600" /> No
            </label>
          </div>
        </div>

        {/* OBSERVACIONES */}
        <div className="col-span-2">
          <label className="block text-xs font-medium text-slate-700 mb-1">Observaciones</label>
          <textarea className={`${inputClass} resize-none`} name="observaciones" placeholder="Observaciones" rows="2" value={form.observaciones} onChange={handleChange} />
        </div>

        {/* BOTON */}
        <button
          onClick={guardar}
          className="col-span-2 flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium py-2 rounded-lg transition"
        >
          <FaUserPlus className="text-xs" /> Registrar
        </button>
      </div>
    </div>
  );
}
